<template>
  <div
    ref="container"
    class="relative select-none"
    :class="{
      'w-8 h-6': hasState('smallIcon'),
      'w-13 h-13': !hasState('smallIcon')
    }"
  >
    <div
      class="flex items-center justify-center text-grey-500 cursor-pointer"
      :class="{
        'w-8 h-5': hasState('smallIcon'),
        'h-13': !hasState('smallIcon')
      }"
      @click="toggleMenu($event)"
    >
      <i v-if="!icon" class="fas fa-ellipsis-h"></i>
      <component
        :is="icon"
        v-else
        class="w-6 h-4 mt-2 cursor-pointer fill-current text-white"
      ></component>
    </div>
    <transition name="fade" mode="out-in">
      <div
        v-if="menuOpen"
        v-on-click-outside="closeMenu"
        :class="[{ 'right-0': !rightSide, 'left-0': rightSide }, dropMenuClass || 'absolute top-0 mt-13 z-40']"
      >
        <div
          class="rounded-lg border-solid border"
          :class="{
            'bg-white text-grey-700 border-grey-200': !hasState('dark'),
            'bg-grey-900 text-white border-grey-800': hasState('dark'),
            'w-40': hasState('small'),
            'w-64': !hasState('small')
          }"
        >
          <div class="p-4 pb-1">
            <div
              v-if="helpText"
              class="mb-3 pb-3 italic text-white border-b border-grey-700 text-sm cursor"
            >
              {{ helpText }}
            </div>
            <div
              v-for="item in menuItems"
              :key="item.text"
              class="drop-menu-item cursor-pointer mb-3 text-sm"
              :class="{
                'cursor-not-allowed text-grey-600': item.disabled,
                'cursor-pointer': !item.disabled
              }"
              @click.stop="callMenuAction(item)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import mixins from '../mixins';
import directives from '../directives';

export default {
  name: 'DropMenu',
  directives,
  mixins: [mixins],
  props: ['menuItems', 'dark', 'icon', 'small', 'smallIcon', 'helpText', 'dropMenuClass'],
  data() {
    return { menuOpen: false, rightSide: false };
  },
  methods: {
    toggleMenu() {
      if (this.$refs.container.getBoundingClientRect().left < 224)
        this.rightSide = true;
      else this.rightSide = false;
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    callMenuAction(menuItem) {
      if (!menuItem.disabled) {
        this.menuOpen = false;
        menuItem.callback();
        this.$emit('action-called');
      }
    }
  }
};
</script>
